import React, {useEffect,useState} from 'react';
import {createPortal} from 'react-dom';
import {ASSISTANT_ACTION_EVENT,ASSISTANT_ACTION_TYPES} from '../../utils/assistantActions';
import {LINKED_STUDENT_STATUS_EVENT} from './linkedStudentNavigation';
import './LinkedStudentNavigationFeedback.css';

export default function LinkedStudentNavigationFeedback() {
  const [pending,setPending]=useState(null);
  useEffect(()=>{
    let timer;
    const start=event=>{
      const action=event.detail, props=action?.tabProps;
      if(action?.type!==ASSISTANT_ACTION_TYPES.OPEN_TAB || action.tabId!=='student-management' || !Number.isSafeInteger(Number(props?.initialStudentId)) || Number(props.initialStudentId)<=0 || !props.initialStudentRequest) return;
      clearTimeout(timer);
      const requestId=props.initialStudentRequest;
      setPending({requestId,name:props.initialStudentName||'Jovem',error:null,slow:false});
      timer=setTimeout(()=>setPending(current=>current?.requestId===requestId?{...current,slow:true}:current),15000);
    };
    const finish=event=>{
      const {requestId,error}=event.detail||{};
      setPending(current=>current?.requestId===requestId?(error?{...current,error}:null):current);
    };
    window.addEventListener(ASSISTANT_ACTION_EVENT,start);
    window.addEventListener(LINKED_STUDENT_STATUS_EVENT,finish);
    return()=>{clearTimeout(timer);window.removeEventListener(ASSISTANT_ACTION_EVENT,start);window.removeEventListener(LINKED_STUDENT_STATUS_EVENT,finish);};
  },[]);
  if(!pending) return null;
  return createPortal(<aside className="linked-student-feedback" role={pending.error?'alert':'status'} aria-live="polite">
    {!pending.error && <span className="linked-student-feedback__spinner" aria-hidden="true"/>}
    <div><strong>{pending.error?'Não foi possível abrir a ficha':'Carregando ficha...'}</strong><p>{pending.name}</p><small>{pending.error || (pending.slow?'O carregamento está demorando. Você pode fechar este aviso e aguardar.':'Aguarde a abertura do cadastro.')}</small></div>
    <button type="button" aria-label="Fechar aviso" onClick={()=>setPending(null)}>×</button>
  </aside>,document.body);
}
